import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterRewardCreatePage } from './master-reward-create.page';

const routes: Routes = [
  {
    path: '',
    component: MasterRewardCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterRewardCreatePageRoutingModule {}
